import React from "react";
import Cnav from "../Contact-Nav/Cnav";
import Gallery from "../Gallery/Gallery";
import Footer from "../Footer/Footer";

function Fifth() {
  return (
    <div>
      <Cnav galleryColor="red" contactColor="black" />
      <Gallery />
      <Footer />
    </div>
  );
}

export default Fifth;
